import ReceiveAddress from './ReceiveAddress';

export default ReceiveAddress;
